import { Component, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { LibTableRecordActionComponent } from '@tuain/ng-forms';
import { tuainFormsBaseModules, tuainBaseComponents } from '@components/tuain.modules';

@Component({
  standalone: true,
  selector: 'app-table-custom-action',
  imports: [...tuainFormsBaseModules, ...tuainBaseComponents],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // La visibilidad se aplica en el host y no con un `@if` alrededor del `<ng-content>`:
  // el contenido proyectado no se puede volver a proyectar si se destruye. `null` deja que
  // manden los estilos estáticos cuando la acción es visible.
  host: {
    '[style.display]': "visible() ? null : 'none'",
  },
})
export class TableCustomActionComponent extends LibTableRecordActionComponent {
  @HostListener('click', ['$event'])
  handleClick(event: MouseEvent) {
    event.stopPropagation();
    this.onActivate();
  }

  override onActivate() {
    const tableEvent = {
      actionCode: this.action?.actionCode ?? '',
      recordId: this.recordId,
      recordData: { ...this.recordData },
    };
    this.actionSelected.emit(tableEvent);
  }
}
